function initCopyOnClick() {
  const els = document.querySelectorAll("[data-copy-on-click]");
  els.forEach((el, index) => {
    const autoClose = el.hasAttribute("data-copy-on-click-autoclose")
      ? !!el.getAttribute("data-copy-on-click-autoclose")
      : true;

    const id = `eza-copy-on-click-tooltip-${index}`;

    const popover = document.createElement("div");
    popover.setAttribute("id", id);
    popover.setAttribute("popover", "");
    popover.classList.add("eza-tooltip"); // HERE, move to file, probably with style below as well
    document.body.append(popover);

    el.setAttribute("popovertarget", id);

    function close() {
      popover.hidePopover();
    }

    async function handleClick() {
      popover.classList.remove("success", "error");
      const url = el.dataset.copyOnClick || false;
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
        popover.classList.add("success");
        popover.innerText = "Copied!";
      } catch (error) {
        popover.classList.add("error");
        popover.innerText = "Error!";
      }

      if (autoClose) setTimeout(close, 2000);
    }

    el.addEventListener("click", handleClick);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCopyOnClick);
} else {
  initCopyOnClick();
}
